<div>
  <app-page>
    <div class="top-cta">
      <dx-button
        [text]="'COMMON.BACK' | translate"
        icon="back"
        type="default"
        class="integration-btn"
        (click)="navigateBack()"
      >
      </dx-button>
      @if(!editingMode){
        <dx-button
          class="cta-btn"
          type="normal"
          [text]="'COMMON.SAVE' | translate"
          (click)="submit()"
        ></dx-button>
      } @else {
        <dx-drop-down-button
          [splitButton]="true"
          text="{{ 'COMMON.SAVE' | translate }}"
          stylingMode="contained"
          type="normal"
          [dropDownOptions]="{ width: 230 }"
          (onButtonClick)="submit()"
        >
          <dxi-item (click)="navigateInviteAttendees()">
            {{ "MANAGE-ELEARNING.DETAIL.ADD-ATTENDEES" | translate }}
          </dxi-item>
          <dxi-item (click)="navigateToActivityLog()">
            {{ "MANAGE-ELEARNING.DETAIL.ACTIVITY-LOG" | translate }}
          </dxi-item>
        </dx-drop-down-button>
      }
    </div>
    <app-page-title
      [title]="
        editingMode
          ? ('MANAGE-LEARNING-PATH.FORM.LEARNING-PATH-TITLE-EDIT' | translate)
          : ('MANAGE-LEARNING-PATH.FORM.LEARNING-PATH-TITLE-ADD' | translate)
      "
    ></app-page-title>
    <div class="row">
      <div class="col-md-12 col-lg-5">
        <app-panel class="image-panel">
          <div id="avatar-upload" class="uploader-container">
            <img
              class="learning-path-image"
              [src]="formData.image"
              *ngIf="formData.image"
            />
            <img
              class="learning-path-image"
              src=""
              appTrainingImageFallback
              *ngIf="!formData.image && editingMode"
            />
            <div
              class="uploader-preview-container"
              *ngIf="!formData.image && !editingMode"
            >
              <img src="assets/img/upload.jpg" />
              <span class="preview-title">{{
                "COMMON.UPLOAD-IMAGE" | translate
              }}</span>
              <span class="preview-description">{{
                "COMMON.UPLOAD-IMAGE-SIZE" | translate
              }}</span>
            </div>
          </div>
          <dx-file-uploader
            #fileUploader
            dialogTrigger="#avatar-upload"
            dropZone="#avatar-upload"
            [multiple]="false"
            [allowedFileExtensions]="['.jpg', '.jpeg', '.gif', '.png']"
            uploadMode="useForm"
            [visible]="false"
            (valueChange)="onCategoryImageSelected($event)"
          ></dx-file-uploader>
        </app-panel>
      </div>
      <div class="col-md-12 col-lg-7">
        <app-panel
          class="training-category-panel"
          [title]="'ADMINISTRATION.TITLE-DESCRIPTION' | translate"
        >
          <dx-form #form labelMode="floating" [formData]="formData">
            <dxi-item dataField="name">
              <dxo-label [text]="'COMMON.FIELDS.NAME' | translate"></dxo-label>
              <dxi-validation-rule
                type="required"
                [message]="'VALIDATIONS.NAME-REQUIRED' | translate"
              ></dxi-validation-rule>
            </dxi-item>
            <dxi-item
              dataField="description"
              editorType="dxTextArea"
              [editorOptions]="{
                height: 145
              }"
            >
              <dxo-label
                [text]="'COMMON.FIELDS.DESCRIPTION' | translate"
              ></dxo-label>
            </dxi-item>
          </dx-form>
        </app-panel>
      </div>
      <div class="col-md-12">
        <app-panel [title]="'ADMINISTRATION.EXTENDED-DESCRIPTION' | translate">
           <app-expandable-text-editor
            *ngIf="formData"
            [(value)]="formData.descriptionExtended"
          ></app-expandable-text-editor>
          <div 
            *ngIf="userContext.canUseTextTemplates"
            class="text-template-container"
          >
            <app-text-template-selector
              [type]="descriptionTextTemplateType"
              [content]="formData.descriptionExtended"
              (contentChange)="onTemplateContentChanged($event)"
            ></app-text-template-selector>
          </div>
        </app-panel>
      </div>
      <div class="col-md-12" *ngIf="editingMode && learningPathId">
        <app-panel [title]="'ADMINISTRATION.PROCESSING-PROGRESS-TITLE' | translate">
          <app-learning-path-persons-table
            #personsTable
            [learningPathId]="learningPathId"
          ></app-learning-path-persons-table>
        </app-panel>
      </div>
      <div class="col-md-12" *ngIf="editingMode">
        <app-panel
          class="learning-path-add-course"
          [title]="'MANAGE-LEARNING-PATH.FORM.LEARNING-UNITS' | translate"
        >
          <dx-button
            class="learning-path-add-course-btn"
            type="normal"
            [text]="'MANAGE-LEARNING-PATH.FORM.ADD-COURSE' | translate"
            [disabled]="isAddCourseDisabled"
            (click)="openAddCourseModal()"
          ></dx-button>
          <dx-tree-list
            id="courses"
            #coursesTreeList
            class="learning-path-courses"
            *ngIf="learningPathCourses && learningPathCourses.length"
            [dataSource]="learningPathCourses"
            [rootValue]="null"
            keyExpr="id"
            parentIdExpr="parentId"
            [showBorders]="false"
            [showColumnLines]="false"
            [showRowLines]="true"
            [columnAutoWidth]="true"
            [allowColumnResizing]="true"
            [columnResizingMode]="'nextColumn'"
            [scrolling]="{ mode: 'standard' }"
            (onSelectionChanged)="coursesSelectionChangedHandler($event)"
            (onRowClick)="coursesRowClickHandler($event)"
            [autoExpandAll]="true"
          >
            <dxo-selection mode="single"></dxo-selection>
            <dxi-column
              [caption]="'COMMON.FIELDS.NAME' | translate"
              dataField="this"
              cellTemplate="detailsTemplate"
              alignment="left"
            ></dxi-column>
            <dxi-column
              caption=""
              dataField="this"
              cellTemplate="actionsTemplate"
              width="70px"
              alignment="left"
            ></dxi-column>
            <div *dxTemplate="let data of 'detailsTemplate'">
              <div class="learning-path-course-wrapper">
                <img class="learning-path-course-image" [src]="data.value.imageUrl"/>
                <div class="learning-path-course-details">
                  <div class="learning-path-course-name">{{data.value.name}}</div>
                  <div class="learning-path-course-description">{{data.value.description}}</div>
                </div> 
              </div>
            </div>
            <div *dxTemplate="let data of 'actionsTemplate'">
              <dx-button
                class="delete-course-btn"
                type="default"
                (click)="onDeleteModuleClick(data.value.id)"
              >
                <i class="dx-icon-close"></i>
              </dx-button>
            </div>
          </dx-tree-list>
        </app-panel>
      </div>
      <!-- <div class="col-md-12" *ngIf="editingMode">
        <app-panel
          [title]="'MANAGE-LEARNING-PATH.FORM.REQUIRED-LEARNING-PATHS' | translate"
        >
          <dx-drop-down-box
            class="required-learning-paths-select"
            [value]="selectedLearningPaths"
            [inputAttr]="{ 'aria-label': 'Owner' }"
            valueExpr="id"
            displayExpr="name"
            [label]="'COMMON.FIELDS.LEARNING-PATHS' | translate"
            [dataSource]="allLearningPaths || []"
            labelMode="floating"
            stylingMode="outlined"
          >
            <div *dxTemplate="let data of 'content'">
              <dx-tree-view
                [searchEnabled]="true"
                [dataSource]="allLearningPaths || []"
                dataStructure="plain"
                keyExpr="id"
                selectionMode="multiple"
                showCheckBoxesMode="normal"
                [selectNodesRecursive]="false"
                displayExpr="name"
                [selectByClick]="true"
                (onItemSelectionChanged)="onLearningPathSelected($event)"
              >
              </dx-tree-view>
            </div>
          </dx-drop-down-box>
        </app-panel>
      </div> -->
      <div class="col-md-12" *ngIf="editingMode">
        <app-panel [title]="'MANAGE-LEARNING-PATH.FORM.UPLOAD-DOCUMENTS' | translate">
          <div class="row">
            <div class="col-md-12 col-lg-5">
              <app-panel class="image-panel">
                <div id="document-upload" class="uploader-container">
                  <div class="uploader-preview-container">
                    <img src="assets/img/upload.jpg" />
                    <span class="preview-title">{{
                      "COMMON.UPLOAD-DOCUMENT" | translate
                    }}</span>
                  </div>
                </div>
                <dx-file-uploader
                  #fileUploader
                  dialogTrigger="#document-upload"
                  dropZone="#document-upload"
                  [multiple]="false"
                  uploadMode="useForm"
                  [visible]="false"
                  (valueChange)="onDocumentSelected($event)"
                ></dx-file-uploader>
              </app-panel>
            </div>
            <div class="col-md-12 col-lg-7">
              <app-panel class="learning-path-panel">
                <div class="files-title">
                  {{ "COMMON.FILES" | translate }} ({{
                    currentLearningPath && currentLearningPath!.files
                      ? currentLearningPath!.files!.length
                      : 0
                  }})
                </div>
                <div
                  class="full-height-list"
                  *ngIf="currentLearningPath && currentLearningPath!.files"
                >
                  <div class="list-wrapper">
                    <dx-list
                      [dataSource]="currentLearningPath!.files!"
                      class="striped-list"
                    >
                      <div *dxTemplate="let item of 'item'">
                        <div class="file">
                          <div class="file-name">
                            <div>{{ item.fileName }}</div>
                            <div class="file-url">
                              {{ item.fileUrl }}
                            </div>
                          </div>
                          <div
                            class="close-action"
                            (click)="onRemoveFileClicked(item)"
                          >
                            <i class="dx-icon-close"></i>
                          </div>
                        </div>
                      </div>
                    </dx-list>
                  </div>
                </div>
              </app-panel>
            </div>
          </div>
        </app-panel>
      </div>
    </div>
  </app-page>
</div>

<app-confirmation-dialog
  [height]="'auto'"
  [(showModal)]="showDeleteFileModal"
  (submit)="onRemoveFileConfirm()"
  [options]="modalConfirmationOptions"
></app-confirmation-dialog>

<app-confirmation-dialog
  [height]="'auto'"
  [(showModal)]="showDeleteCourseModal"
  (submit)="onConfirmDeleteCourse()"
  [options]="deleteCourseModalOptions"
></app-confirmation-dialog>

<app-confirmation-dialog
  [height]="'auto'"
  [showModal]="showWarningAddCoursePopup"
  (showModalChange)="onShowModalChange($event)"
  (submit)="onConfirmAddCourse()"
  [options]="addCourseModalOptions"
></app-confirmation-dialog>

<dx-popup
  [width]="500"
  [height]="270"
  [showTitle]="true"
  [title]="'MANAGE-LEARNING-PATH.FORM.ADD-COURSE' | translate"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  class="modal"
  [wrapperAttr]="{ class: 'learning-path-add-course-modal' }"
  [classList]="'modal'"
  [visible]="showAddCourseModal"
  (onHidden)="onCloseAddCourseModal()"
>
  <div *dxTemplate="let data of 'content'" class="modal-content">
    <div class="modal-text">
      <dx-select-box
        [items]="availableCourses || []"
        [value]="selectedCourseIdToAdd"
        [inputAttr]="{ 'aria-label': 'Owner' }"
        valueExpr="id"
        displayExpr="name"
        [searchEnabled]="true"
        [label]="'COMMON.FIELDS.EVENT-TYPES.ELEARNING' | translate"
        labelMode="floating"
        stylingMode="outlined"
        (onValueChanged)="onCourseSelected($event)"
      >
      </dx-select-box>
    </div>
    <div class="modal-button-container">
      <dx-button
        [text]="'MANAGE-LEARNING-PATH.FORM.ADD-MODULE' | translate"
        type="normal"
        (click)="onAddModule()"
      >
      </dx-button>
    </div>
  </div>
</dx-popup>